import * as yup from "yup";

const ConceptosCobroValidacionEsquema = yup.object().shape({
    nombre: yup.string().required(),
    claveSAT: yup.string().required()
});

export default ConceptosCobroValidacionEsquema;